module.exports = function() {
  return new Worker(__webpack_public_path__ + "618116c04128af020930.worker.js");
};